import { useState, useEffect } from 'react'
import { supabase } from '@/lib/supabase'
import type { SearchResult } from '@/types'

export function useSearch(query: string) {
  const [results, setResults] = useState<SearchResult[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!query.trim()) { setResults([]); return }
    setLoading(true)
    supabase.rpc('search_knowledge', { query: query.trim() }).then(({ data }) => {
      setResults((data ?? []) as SearchResult[])
      setLoading(false)
    })
  }, [query])

  return { results, loading }
}
